import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { loadFromStorage } from "@/lib/store/auth/authSlice";

export function ReduxHydrator() {
  const dispatch = useDispatch();

  useEffect(() => {
    if (typeof window !== "undefined") {
      dispatch(loadFromStorage());
    }
  }, [dispatch]);

  return null;
}
